// utils/contentSquare.ts

/**
 * Injects the `data-cs-override-id` attribute on the first element inside the shadow root
 * that has an `id` attribute, to prevent Contentsquare from tracking the `id`.
 *
 * This utility is intended to be used inside Web Components that render HTML into a shadow DOM.
 *
 * @param {ShadowRoot | null} shadowRoot - The shadow root to search within.
 */
export function applyContentSquareOverride(shadowRoot: ShadowRoot | null): void {
	if (!shadowRoot) return;

	const target = shadowRoot.querySelector('[id]');
	if (target && !target.hasAttribute('data-cs-override-id')) {
		target.setAttribute('data-cs-override-id', '');
	}
}
